import React from 'react';
import { Card } from '@/components/ui';

interface BulkProgressProps {
    totalFiles: number;
    uploadedCount: number;
    processedCount: number;
    isProcessing: boolean;
}

export function BulkProgress({
    totalFiles,
    uploadedCount,
    processedCount,
    isProcessing,
}: BulkProgressProps): React.JSX.Element {
    const uploadProgress = totalFiles > 0 ? Math.round((uploadedCount / totalFiles) * 100) : 0;
    const processProgress = totalFiles > 0 ? Math.round((processedCount / totalFiles) * 100) : 0;

    return (
        <Card className="mb-6">
            <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Bulk Processing Status</h3>

                <div className="space-y-6">
                    {/* Upload Progress */}
                    <div>
                        <div className="flex justify-between mb-2">
                            <span className="text-sm font-medium text-gray-700">Uploading Images</span>
                            <span className="text-sm text-gray-600">
                                {uploadedCount} / {totalFiles}
                            </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                            <div
                                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                                style={{ width: `${uploadProgress}%` }}
                            ></div>
                        </div>
                    </div>

                    {/* Processing Progress */}
                    {(isProcessing || processedCount > 0) && (
                        <div>
                            <div className="flex justify-between mb-2">
                                <span className="text-sm font-medium text-gray-700">Creating Orders</span>
                                <span className="text-sm text-gray-600">
                                    {processedCount} / {totalFiles}
                                </span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div
                                    className="bg-green-600 h-2.5 rounded-full transition-all duration-300"
                                    style={{ width: `${processProgress}%` }}
                                ></div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
}
